/**
 * FLET RÆKKER / «Højde» — midlertidigt skjult i UI
 * ===============================================
 *
 * Sæt `SHOW_ROW_SPAN_UI` til `true` for at vise funktionen igen.
 *
 * Hvad funktionen gør
 * -------------------
 * Knappen «Højde» på episodebaren slår et træk-greb til under billed-
 * og lydsiden. Brugeren trækker, så én celle dækker flere rækker
 * (`visualRowSpan` / `audioRowSpan`). Konflikt-dialog ved overlap
 * (ryd eller flet dækket indhold).
 *
 * Datamodel (rør ikke — beholdes mens UI er skjult)
 * --------------------------------------------------
 * `packages/document-model/src/index.ts`
 *   - `Cue.visualRowSpan` / `Cue.audioRowSpan`
 *   - `layoutDualColumnSpans`, `setVisualRowSpan`, `setAudioRowSpan`
 *
 * App-wiring (kaldes stadig; knappen er bare skjult)
 * --------------------------------------------------
 *   - `apps/web/src/App.tsx` → `onSetVisualSpan` / `onSetAudioSpan`
 *   - `apps/desktop/src/App.tsx` — samme
 *
 * UI der styres af dette flag
 * ----------------------------
 *   - `FormatToolbar` — knappen «Højde»
 *   - `EpisodePageBar` / `ScriptEditor` — `rowSpanMode`
 *   - `DualColumnScript` — træk-greb, «N rækker»-badge, ghost,
 *     `SpanConflictDialog` (`VisualSpanConflictDialog.tsx`)
 *   - `helpContent` — afsnit og tip om Højde
 *
 * Layout/print/export bruger stadig span-felterne, så eksisterende
 * dokumenter ikke mister fletning. CSS: `.sm-visual-resize`,
 * `.sm-audio-resize`, `.sm-span-badge`, `.is-row-span-mode`.
 */
export const SHOW_ROW_SPAN_UI = false;
